import { TactsuitInteractionScrollCanvas } from "@/components/tactsuit/tactsuit-interaction-scroll-canvas";
import Container from "@/components/commons/Container";
import { useInteractionScrollImgLoaded } from "@/hooks/tactsuit/use-interaction-scroll-img-loaded";
import { TactsuitSleeveInteractionScrollInfo } from "@/v2-components/pages/tactsuit/tacsuit-sleeve/components/tactsuit-sleeve-interaction-scroll-info";

export const TactsuitSleeveInteractionScrollContainer = () => {
  const { images, isLoaded } = useInteractionScrollImgLoaded();

  return (
    <Container className="labtop:mx-4 mx-0 flex w-full flex-1 flex-col items-center bg-coolgray-10">
      <div className="align-center flex w-full flex-col gap-6 laptop:flex-row">
        <TactsuitInteractionScrollCanvas images={images} imagesRange={100} />
        <TactsuitSleeveInteractionScrollInfo />
      </div>
    </Container>
  );
};
